export const SCOPE_SNSAPI_BASE = 'snsapi_base';
export const SCOPE_SNSAPI_USERINFO = 'snsapi_userinfo';



// WEBPACK FOOTER //
// ./src/constants/wechat.js